<template>
	<div class="g-container" style="background: #f8fafc">
		<!--图片banner-->
		<div class="m-slider-banner h-banner-400">
			<swiper :options="swiperOption" ref="mySwiper">
				<!-- slides -->
				<swiper-slide v-for="(item,index) in detail.banner" :key="index">
					<a class="oper-pic" :style="{backgroundImage:'url(' + item + ')'}" :href="item.outLink">
					</a>
				</swiper-slide>

				<!-- Optional controls -->
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
			<div class="mack-top">
				<div class="mack"></div>
				<div class="font-mack">
					<div class="projects">
						<div style="font-size:16px;margin-bottom: 5px;">项目简介</div>
						<span>{{detail.desc}}</span>
					</div>
					<div class="projects">
						<div style="font-size:16px;margin-bottom: 5px;">工程概况</div>
						<span>工程质量：{{detail.quality}} <br/> 工程规模：{{detail.scale}} <br/> 工程周期：{{detail.cycle}}<br/></span>
					</div>
				</div>
			</div>
		</div>
		<div class="m-container m-width">
			<!--面包屑-->
			<div class="crumbs-box">
				<router-link tag="a" class="c-crumbs" :to="{name:'default'}">首页</router-link>
				<span class="c-sep">&gt;</span>
				<router-link tag="a" class="c-crumbs" :to="{name:'caseIndex'}">云课件</router-link>

				<span class="c-sep">&gt;</span>
				<span class="c-current">{{detail.title}}</span>
			</div>
			<!--案例详情-->
			<div class="dis_inline_block g-case-detail postop_220 ">
                <div class="pro_coursewares">
                    <b class="Project_name">{{detail.title}}</b>
                    <div class="width_size">
                        <div class="courseware"><span class="line"></span><span class="kejian1">项目课件</span><div class="right_ke"><span style="cursor: pointer;" v-if="uesrRole" @click="goCourse">上传课件</span></div></div>
                        <div class="maBot55 dis_inline_block" v-if="list.length >0">
                            <div class="videoimgs maTop20" v-for="(item,index) in list" :key="index">
								<i class="bofangs" @click="videos(index)" :id="'play_'+index" :data-playId ="item.Id"></i>
								<img class="tup" :src="item.VideoBgUrl" :id="'Bgimg_'+index">
                                <video :src="item.VideoUrl" :data-src="item.VideoUrl" width="100%" :data-playId ="item.Id" :data-index="index" class="videos myVideo"></video>
                                <i class="FDaimg" @click="openPopVideo(item.Id,item.VideoUrl)">
									<i class="FDa"></i>
								</i>
                                <div class="maTop9">
                                    <div class="detail_name">{{item.Title}}</div>
                                    <div class="detail_ico flex maTop15">
                                        <div class="flex floatLeft"><i class="times"></i><span class="font_location">{{item.VideoTime}}</span></div>
                                        <div class="flex floatRight paddR5"><i class="ship"></i><span class="font_location">{{item.PlayCount}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="width_size">
                        <div class="courseware"><span class="line"></span><span class="kejian1">项目回顾</span><div class="right_ke"></div></div>
                        <div class="maTop30 maRight15"  v-for="(item,index) in projects" :key="index">
                            <b class="font18 top_10">{{item.year}}</b>
                            <div class="maLeft32 line_left">
                                <div class="paddL60">
                                    <i class="time-number">{{item.day}}</i>
									<div style="margin-top: -20px;cursor: pointer;" @click="originality(item.id)" >
										<div style="display: flow-root;">
											<div class="flex floatLeft">
												<span class="font16 color333">{{item.title}}</span> 
												<span class="dailys hong" v-if="item.postType == '日报'">{{item.postType}}</span>
												<span class="dailys lan" v-if="item.postType == '周报'">{{item.postType}}</span>
												<span class="dailys yell" v-if="item.postType == '图文'">{{item.postType}}</span>
												<span class="dailys lv" v-if="item.postType == 'QE'">{{item.postType}}</span>
											</div>
											<div class="floatRight color999"><i class="eye maRight"></i>{{item.hits}}人看过</div>
										</div>
										<div class="color666 maTop9 font_length">{{item.content}}</div>
										<img v-for="(pic,i) in item.images" :key="i" class="dailyImg maBot30"  :src="pic" alt >
									</div>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="maBot30">
                            <el-pagination background layout="prev, pager, next" :total="count" 
							:pager-count="5" :page-size="pageSize" :current-page.sync="currentPage" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
                        </div>
                    </div>
                    <div class="width_size" v-if="detail.warrantys !=''">
                        <div class="courseware"><span class="line"></span><span class="kejian1">竣工验收单</span><div class="right_ke"></div></div>
                        <div class="maBot30" >
							<span v-if="typeOf">
								<img v-for="(txt,j) in detail.warrantys" :key="j" class="receipt maTop30 a" :src="txt.thumpic" alt="" >
							</span>
							<span v-else>
								<img v-for="(txt,j) in detail.warrantys" :key="j" class="receipt maTop30" :src="txt" alt="" >
							</span>
                            
                        </div>
                    </div>
                </div>
            </div>
			<div class="m-cases-contents_right postop_220">
                <div class="product_name">
                    <div class="font16 font_bold color333">产品名称</div>
                    <div class="" v-for="(item,index) in detail.product" :key="index" @click="goCloud(item.id)">
                        <img class="productImg maTop15 maBot15" :src="item.picPath" alt="">
                        <div class="color4d maBot10">{{item.title}}</div>
                    </div>
                </div>
                <div class="product_name maTop20 maBot20" :class="show1 == false ? 'max_h':'kongs'" v-if="detail.detInfos !=''">
                    <div class="font16 font_bold color333">检测报告</div>
                    <ul class="report" style="margin-top: 7px;">
                        <li v-for="(item,index) in detail.detInfos" class="color999 hover_color"  @click="detFunc(item)">{{item.title}}</li>
                    </ul>
                    <div>
                        <div class="pos_a" v-if="!show1" @click="open">
							<span class="shou color333"  >展开 </span>
							<i class="kai"></i>
						</div>
						<div class="pos_a" v-else @click="open2">
							<span class="shou color333"  >收起 </span>
							<i class="kai xuan"></i>
						</div>
                    </div>
                </div>
                <div class="product_name maTop20" :class="show2 == false ? 'max_h':'kongs'" v-if="detail.qe !=''">
                    <div class="font16 font_bold color333">QE报告</div>
                    <ul class="report" style="margin-top: 7px;">
                        <li v-for="(txt,index) in detail.qe" :key="index" class="color999"  @click="goDetail(txt.Id)"> <span class="hover_color">{{txt.Name}} </span><br>{{txt.CreatedTime}}</li>
                    </ul>
                    <div>
                        <div class="pos_a" v-if="!show2" @click="open1" >
							<span class="shou color333" >展开 </span>
							<i class="kai"></i>
						</div>
						<div class="pos_a" v-else @click="open3">
							<span class="shou color333" >收起 </span>
							<i class="kai xuan"></i>
						</div>
                    </div>
                </div>
                <div class="product_name maTop20">
                    <div class="weixing">
                        <div  class="textCenter " id="qrCode" ref="qrCodeDiv" >
                            <i class="qrcode_iduilv_1"></i>
                        </div>
                        <div class="textCenter"><span>扫一扫，手机浏览本产品</span></div>
                    </div>
                </div>
            </div>
		</div>
		<!--视频弹框 显示 +show-->
		<div class="shadow-fixed show" v-show="popVideoDir">
			<div class="mask">
			<div class="mask_top" >
				<div class="bomb-small-close"  @click="closePopVideo"></div>
				<div class="bomb-video-box">
					<video style="width:100%;height:100%;" ref="popVideo" class="video-area" autoplay controls="true"></video>
					<!--播放按钮 显示 +show-->
					<i class="video-icon"></i>
				</div>
			</div>
			</div>
		</div>
	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.css';
	import '../../../../html/pages/cases/details/details.scss';
	import '../../../../html/components/picture/picture.scss';
	import '../../../../html/components/comments/comments.scss';

	import {getCaseDetail,getCourseware,playNum,getProjectEnd} from '../../../../api/index';
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper';
	export default {
		name: 'case-detail',
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				//uesrRole:true,
				uesrRole:false,
				isHauto: false,
				detail: {},
				swiperOption: {
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					autoplay: {
						delay: 8000
					}
				},
				popVideoDir:false,
				currentImgShow: false,
				swiperOption3: {
					initialSlide: 0,
					simulateTouch: false,
					loop: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}

				},
				currentImgList: [

				],
				list: [],


				show1:false,
            	show2:false,
				detInfos:[],
				projects: [],
				count:0,
				pageSize:10,
				currentPage:1,
				typeOf:false,
				loading: false,
			};
		},
		methods: {
			closePopVideo() {
				this.$refs.popVideo.pause();
				this.popVideoDir = false;
			},
			openPopVideo(id,url){
				this.$refs.popVideo.src = url;
            	this.$refs.popVideo.play();
				this.popVideoDir = true;
			},
			originality(id){
				let routeData = this.$router.resolve({ name: 'jxjPostDetail', params: { id: id } });
				window.open(routeData.href, '_blank');
			},
			goDetail(id) {
				let routeData = this.$router.resolve({ name: 'jxj', params: { id: id } });
				window.open(routeData.href, '_blank');
			},
			goCloud(id){
				let routeData = this.$router.resolve({ name: 'cloudDetail', params: { id: id } });
				window.open(routeData.href, '_blank');
			},
			handleCurrentChange(val){
				this.currentPage = val;
				this.getData();
			},

			handleSizeChange(val){
				this.pageSize = val;
			},
			//获取数据
			async getData(type) {
			// this.params = 'all';
			let res = await getProjectEnd({
				id:this.$route.params.id,
				index:this.currentPage-1,
				size:this.pageSize

				});
			if (res.Type == 'Success') {
				this.loading = false;
				this.trace = res.Data;
				this.projects = res.Data.projectEnd;
				this.count = res.Data.count;
				// this.currentPage = res.Data.index+1;
				this.projects.forEach(item => {
				item.year =
					item.createdTime.split(' ')[0].split('-')[0] +
					'.' +
					item.createdTime.split(' ')[0].split('-')[1];
				item.day = item.createdTime.split(' ')[0].split('-')[2];
				// console.log(item.year, item.day);
				});

			} else {
				this.$layer.alert(res.Content);
			}
			},
			open(){
				this.show1 = true
			},
			open2(){
				this.show1 = false
			},
			open1(){
				this.show2 = true
			},
			open3(){
				this.show2 = false
			},
			videos(index){
				let myVideoList = document.getElementsByClassName('myVideo');
				myVideoList[index].play(); //播放视频
				let play_id = document.getElementById('play_'+index);
				play_id.style.display = "none";
				let Bgimg_id = document.getElementById('Bgimg_'+index);
				Bgimg_id.style.display = "none"
				let data = {
					id:myVideoList[index].getAttribute('data-playId'),
				}
				let  res =  playNum(data);
				this.addPlayNum(index)
			},
			goCourse(){
				let routeData = this.$router.resolve({ name: 'caseCourse', params: { id: this.$router.currentRoute.params.id } });
      			window.open(routeData.href, '_blank');
			},

			showDetMore() {
				this.isHauto = !this.isHauto;
			},
			openPopImgList(i, type) {
				if (type == 1) {
					this.currentImgList = res.Data.warrantys
					this.swiperOption3.initialSlide = i;
				} else {
					this.currentImgList = i;
					this.swiperOption3.initialSlide = 0;

				}

				// console.log(this.currentImgList);
				this.currentImgShow = true;

			},
			// 增加播放量
			addPlayNum(index){
				let that = this;
				let myVideoList = document.getElementsByClassName('myVideo');
				for(let val of myVideoList){
					let data = {
						id:val.getAttribute('data-playId'),
					}
						val.addEventListener('play',function(){
							// let  res =  playNum(data);
							// that.getCourseware()
							// this.courseware[val.getAttribute('data-index')].PlayCount = res.Data
							// console.log(res)
						})
						val.addEventListener('ended',function(){
							let play_id = document.getElementById('play_'+index);
							play_id.style.display = "block";
							let Bgimg_id = document.getElementById('Bgimg_'+index);
							Bgimg_id.style.display = "block"

						})
				} 
				
			},
			detFunc(det) {
				if (det.outLink) {
					window.open(det.outLink, '_blank');
				} else{
					var data = JSON.stringify(det.ImgUrl)
					let routeData = this.$router.resolve({name: "reportImg",query: {id:this.$route.params.id,current_id:det.Id}});
      				window.open(routeData.href, '_blank');
					// this.openPopImgList(det.ImgUrl, 2)
				}
			},
			closePopimglist() {
				this.currentImgShow = false;
			},
			async getDetail() {
				let res = await getCaseDetail({
					id: this.$route.params.id
				});
				// console.log(res)
				if (res.Type == 'Success') {
					this.detail = res.Data;
					this.detInfos = res.Data.detInfos

					
					if (res.Data.warrantys.typeof==undefined ) {
					    this.typeOf=true
					}else{
						this.typeOf=false
					}
				}
			},
			async getCourseware() {
				var _this = this
				let res = await getCourseware({
					//forumId: 123   
					forumId: this.$route.params.id
				});
				if (res.Type == 'Success') {
					_this.list = res.Data.list;
					for(let val of _this.list){
						if(val.VideoUrl.indexOf('https') == -1){
								val.VideoUrl = 'https://www.iduilv.com'+val.VideoUrl;
						}

					}
					// this.list = list
					// res.Data.list.forEach((item) => {
					// 	// var a = Object.assign(item,{imageList:[item.imageOne,item.imageTwo]})
					// 	this.courseware.push(Object.assign(item, {
					// 		videoUrl: `https://www.iduilv.com${item.VideoUrl}`
					// 	}))
					// })

					// this.courseware = res.Data.list;
					this.uesrRole = res.Data.CanOperat;
					let that = this;
					setTimeout(function(){
							// that.addPlayNum()
					},200)
				
					// this.detail = res.Data;
					// console.log(this.detail);
					// if (res.Data.warrantys) {
					//     this.currentImgList = res.Data.warrantys
					// }
				}
			}
		},
		created() {
			
			this.getDetail();
			this.getCourseware();
			this.getData()
		},
		watch: {
			$route(to, from) {
			this.getDetail();
			this.getCourseware();
			this.getData()
			}
		},


	};
</script>

<style scoped>

.case-common-title{
	line-height: 36px;padding-left:8px;
}
.case-list{
	display: flex;width: 100%;flex-wrap: wrap;
}

	.videoList {
		margin: 30px 34px 20px 0px;
		width: 340px;
		height: 420px;
		background: #F7F7F7;
		
	}
	.videoList:nth-child(3n+3){
		margin-right: 0px;
	}
	.videoList .explain div{
		width: 100%;
	  color:#999999;
	}

    .explain{
		  display: flex;
		  justify-content: space-around;
		  width: 100%;
		  align-items: center;
	 }
	 .explain img{
		 vertical-align: unset;
	  }
	video {
		width: 340px;
		height: 280px;
		object-fit: fill;
	}
	
	.title{
		font-size: 16px;
		line-height: 24px;
		color: #333;
		margin: 23px 12px 16px  15px;
		width: 313px;
		height:48px;
		display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2; overflow: hidden;
	}
	.duration{
		height: auto;
		margin-top: 16px;
		margin-left: 15px;
	}
	.sum{
		
		height: auto;
		margin-top: 16px;
		text-align: right;
	  margin-right: 15px;
	}
	.tup{
		width: 160px;
   		height: 144px;
		position: absolute;
		z-index: 1;
	}
   .bofang_video{
		 position: absolute;
		 left: calc(50% - 34px);
		 top:calc(50% - 90px);
		 z-index:2;
	 }
	 .dailyImg:hover, .productImg:hover, .receipt:hover{transform: scale(1.06);transition: all .4s ease-in-out;cursor: pointer;}

</style>
